// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3x17e","rightAdornment":"Header_rightAdornment__2eI1U"};